import * as types from '../actions/types';

const initialState = {
  filters: { syid: 0, idcurriculum: 0, cid: 0, page: 0 },
  list: [],
  count: 0,
  isLoading: false,
  hasLoaded: false,
  loadError: null,
  tree: null,
  isLoadingTree: false,
  treeError: null,
  lesson: null,
  isLoadingLesson: false,
  lessonError: null,
};

export default function thematicPlanning(state = initialState, action) {
  switch (action.type) {
    case types.THEMATIC_PLANNING_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.filters } };
    case types.THEMATIC_PLANNING_FETCH_STARTED:
      return { ...state, isLoading: true, loadError: null };
    case types.THEMATIC_PLANNING_FETCH_COMPLETED:
      return { ...state, isLoading: false, hasLoaded: true, loadError: null, list: action.list, count: action.count };
    case types.THEMATIC_PLANNING_FETCH_FAILED:
      return { ...state, isLoading: false, list: [], count: 0, loadError: action.status || true };
    case types.THEMATIC_PLANNING_TREE_FETCH_STARTED:
      return { ...state, isLoadingTree: true, treeError: null };
    case types.THEMATIC_PLANNING_TREE_FETCH_COMPLETED:
      return { ...state, isLoadingTree: false, tree: action.data };
    case types.THEMATIC_PLANNING_TREE_FETCH_FAILED:
      return { ...state, isLoadingTree: false, tree: null, treeError: action.status };
    case types.THEMATIC_PLANNING_TREE_CLEAR:
      return { ...state, tree: null, treeError: null };
    case types.THEMATIC_PLANNING_LESSON_FETCH_STARTED:
      return { ...state, isLoadingLesson: true, lessonError: null, lesson: null };
    case types.THEMATIC_PLANNING_LESSON_FETCH_COMPLETED:
      return { ...state, isLoadingLesson: false, lesson: action.data };
    case types.THEMATIC_PLANNING_LESSON_FETCH_FAILED:
      return { ...state, isLoadingLesson: false, lesson: null, lessonError: action.status };
    case types.THEMATIC_PLANNING_LESSON_CLEAR:
      return { ...state, lesson: null, lessonError: null, isLoadingLesson: false };
    default:
      return state;
  }
}
